export enum ProjectTypeEnum {
    Internal = 1,
    Commercial = 2,
    Thesis = 3
}

